import React from "react";
import Header from "./main/Header";
import Footer from "./main/Footer";
import Routing from "./main/Routing";
import { BrowserRouter, Route, Switch, useLocation } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ToastProvider } from "./base/ToastProvider";
import CToast from "./components/src/CToast";

const themeMain = createTheme({
  palette: {
    primary: {
      main: "#042560",
    },
    secondary: {
      main: "#3CB043",
    },
  },
});

function App() {
  return (
    <>
      <ThemeProvider theme={themeMain}>
        <ToastProvider>
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </ToastProvider>
      </ThemeProvider>
    </>
  );
}

function AppContent() {
  const location = useLocation();

  return (
    <>
      <Header />
      <CToast />
      <Routing />
      <Footer />
    </>
  );
}

export default App;
